export class GapiNotAvailableError extends Error {
  constructor() {
    super("GapiNotAvailableError")
  }
}
